module.exports = __webpack_public_path__ + "static/media/shape-3.c325f8ba.webp";